// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__31gmd","header":"Messages_header__2edV0"};